import script from "./NavSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavSideBar.vue?vue&type=script&setup=true&lang=js"

import "./NavSideBar.vue?vue&type=style&index=0&id=7861a44e&scoped=true&lang=css"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7861a44e"]])

export default __exports__